import { render, staticRenderFns } from "./RevisionTemperatureStep.vue?vue&type=template&id=67836732&scoped=true&"
import script from "./RevisionTemperatureStep.vue?vue&type=script&lang=js&"
export * from "./RevisionTemperatureStep.vue?vue&type=script&lang=js&"
import style0 from "./RevisionTemperatureStep.vue?vue&type=style&index=0&id=67836732&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67836732",
  null
  
)

export default component.exports